import * as React from 'react';
import { Product } from '~/Api/Product';
import { RoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		roMaxPrice: RoMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ roMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => roMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[roMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'RoMaxPrice.ProductProvider';
